// import $ from 'jquery';
import { a11yNavigation } from '@mindkomm/a11y-navigation';
import { initLazyImages } from '@mindkomm/lozad';
import { slideup } from '@mindkomm/slideup';
import { smoothScroll } from '@mindkomm/smooth-scroll';
import { releaseFocus } from '@mindkomm/utils';
import animation from './animation';
import AOS from 'aos';
import { forEach } from '@mindkomm/utils';

/**
 * Main function.
 *
 * This function is called when all polyfills are loaded.
 * Put all custom functionality into this function.
 */
export default function main() {
  const a11yNav = a11yNavigation('#nav-primary');
  a11yNav.init();

  animation();

  slideup({ openOnStartup: false });

  initLazyImages();

  AOS.init();

  document.addEventListener('mousemove', function(event) {
    var mouseXpercentage = Math.round((event.pageX / window.innerWidth) * 100);
    var mouseYpercentage = Math.round((event.pageY / window.innerHeight) * 100);
    forEach(document.querySelectorAll('.radial-gradient'), el => {
      el.style.background =
        'radial-gradient(circle at ' +
        mouseXpercentage +
        '% ' +
        mouseYpercentage +
        '%, #D6E3E7 0, #F8FAFB 30%)';
    });
  });

  /**
   * Fix images when using FacetWP.
   */
  /*$(document).on('facetwp-loaded', function() {
    initLazyImages();
  });
  */

  /**
   * Add smooth scrolling to links, except for links with
   * attribute 'data-ignoresmoothscroll'.
   */
  smoothScroll('a[href*="#"]:not([href="#"]):not([data-ignoresmoothscroll])', {
    useTargetFocus: false
  });

  // Remove focus on links when click is released.
  releaseFocus();

  // Forms
  /*if (typeof window.Formhandler !== 'undefined') {
    window.Formhandler.initAll();
  }*/
}

